module.exports = __webpack_public_path__ + "img/location.2cb1b992.svg";